<template>
  <v-toolbar
    app
    :height="50"
    class="cmp-main-breadcrumb"
    :class="topToolbarClass"
  >
    <div class="left-side">
      <img
        v-if="!value"
        @click.stop="sideIconClicked"
        src="static/icons/burger-menu.svg"
        class="dt-icon sidenav-button"
        alt=""
      />
      <!-- <v-toolbar-side-icon class="sidenav-button" ></v-toolbar-side-icon> -->
    </div>
    <!-- <v-toolbar-items class="hidden-sm-and-down">
      <v-breadcrumbs>
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item
          v-for="item in items"
          :key="item.text"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </v-toolbar-items> -->
    <div class="right-side">
      <div
        v-if="isCurrentSubmoduleRefreshable"
        class="dt-icon-container"
        style="margin-right: 4px"
      >
        <img
          class="dt-icon v5 s2"
          src="static/icons/refresh.svg"
          alt=""
          @click="onListRefresh"
        />
      </div>
      <div class="switch-link">
        <button class="no-bg">
          <a target="_blank" :href="v1Route" style="color: #828282">V1</a>
        </button>
        <button class="dt-button">V2.0</button>
      </div>
      <div class="switch-link">
        <img
          height="30"
          width="30"
          style="cursor: pointer; margin-right: 20px; margin-left: 10px"
          :src="heartBeatSrc"
          @mouseover="hover = true"
          @mouseleave="hover = false"
          @click="onHeartBeatClick"
        />
      </div>
      <div class="help-menu ut-flex">
        <img
          class="dt-icon v5 s2"
          style="cursor: pointer; margin-right: 20px"
          src="static/icons/help.svg"
          alt="help"
          @click="onHelpClick"
        />
      </div>

      <Dropdown
        :options="languagesTV"
        :selected="selectedLanguage"
        :i18nKey="true"
        v-on:selectedChange="(e) => onLanguageChange(e)"
        :placeholder="'Language'"
      ></Dropdown>
      <v-menu transition="slide-y-transition" min-width="135" offset-y>
        <!-- <v-btn
          id="account-menu"
          :title="`Hello, ${this.accountName}`"
          slot="activator"
          icon
        >
        </v-btn> -->
        <div
          slot="activator"
          class="dt-icon-container hv1 user"
          :title="`Hello, ${this.accountName}`"
          style="width: 50px; height: 50px"
        >
          <img
            @click="onAccountIconClick"
            src="static/icons/user.svg"
            style="margin: auto"
            class="dt-icon v5 nohover s1"
            alt="User Account"
            title="User Account"
          />
        </div>
        <div class="dropdown account-dropdown-menu">
          <div class="dropdown--list">
            <div
              @click="onMyDetailsClick"
              class="dropdown--item"
              id="account-menu--details"
            >
              <div class="dropdown--item--text">My Details</div>
            </div>
            <div @click="onMyBillingClick" class="dropdown--item">
              <div class="dropdown--item--text">My Billing</div>
            </div>
            <div @click="onNoticesClick" class="dropdown--item">
              <div class="dropdown--item--text">Notices</div>
            </div>
            <div
              @click="onLogoutClick"
              class="dropdown--item"
              id="account-menu--logout"
            >
              <div class="dropdown--item--text">Logout</div>
              <div class="dropdown--item--icon">
                <div class="dt-icon-container">
                  <img
                    src="static/icons/logout.svg"
                    class="dt-icon"
                    alt="Logout"
                    title="Logout"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
import Dropdown from "@plugins/dropdown/dropdown";
import { mapGetters, mapActions } from "vuex";
import { storeModules } from "../../store";
import * as AccTypes from "../../store/app/types";
import { openModalRoute } from "../../dt-plugins/modal/modal.mixin";
import { MHTTPCL } from "../../services/http/http-client";
import { HEART_BEAT_URL } from "../../services/common-urls.js";
import * as SettingsUserActionTypes from "../../modules/settings/store/users/types";
import { SettingsStoreNamespace } from "../../modules/settings/store";
import {
  refreshCurrentSubmodule,
  isCurrentSubmoduleRefreshable,
} from "../../dt-plugins/advanced-search/list-refresher";

export default {
  components: {
    Dropdown,
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      topToolbarClass: {
        "top-toolbar": true,
      },
      hover: false,
    };
  },
  computed: {
    ...mapGetters([
      "getBreadcrumbs",
      "appNavItems",
      "systemLanguagesTV",
      "systemLanguage",
      "account",
    ]),
    items: function () {
      return this.getBreadcrumbs(this.$route.path).map((e) => {
        return {
          text: e,
          disabled: false,
        };
      });
    },
    languagesTV: function () {
      return this.systemLanguagesTV.map((s) => {
        return {
          text: this.$dft.capHead(this.$t(s.text)),
          value: s.value,
        };
      });
    },
    selectedLanguage: function () {
      return {
        text: this.$dft.capHead(this.$t(this.systemLanguage.text)),
        value: this.systemLanguage.value,
      };
    },
    accountName: function () {
      return (
        this.account && this.account.user && this.account.user.staff_fullname
      );
    },
    v1Route: function () {
      return `${MHTTPCL.getBaseUrl()}/index.pl?start=1`;
    },
    heartBeatSrc: function () {
      if (!this.hover) {
        return "static/icons/heart-beat.png";
      } else {
        return "static/icons/heart-beat-hover.png";
      }
    },
    isCurrentSubmoduleRefreshable() {
      // console.log({'main-breadcrumb.vue:219 this.$route.name' : this.$route.name});
      return [
        "invoices",
        "invoice_reminders",
        "costs",
        "booking_list",
        "booking_calendar",
        "booking_tasks",
        "booking_requests",
        "promoters",
        "venues",
        "artists",
        "templates",
        "contact_list",
        "settings_language",
        "identities",
        "users",
        "externalusers",
        "notices",
        "imports",
        "accounts",
        "orders",
        "suppliers",
        "statement_list",
        "shops",
        "shop_groups",
        "supplier_order",
        "release_report",
        "catalog_artists",
        "labels",
        "projects",
        "releases",
        "products",
        "tracks",
        "product_groups",
        "royalty_accounts",
        "contracts",
        "statements",
        "Recoupable",
        "licence_accounts",
        "licences",
      ].includes(this.$route.name);
    },
  },
  mounted: function () {},
  methods: {
    ...mapActions({
      [AccTypes.UPDATE_SYSTEM_LANGUAGE]: AccTypes.UPDATE_SYSTEM_LANGUAGE,
      [AccTypes.LOGOUT]: AccTypes.LOGOUT,
    }),
    sideIconClicked: function (event) {
      this.$store.dispatch(AccTypes.TOGGLE_SIDE_NAV);
    },
    isDev() {
      return (
        window.location.origin == "https://dev.berlin3.com" ||
        window.location.origin == "http://localhost:8080"
      );
    },
    onLanguageChange: function (event) {
      console.log("Lang Changed", event);
      this[AccTypes.UPDATE_SYSTEM_LANGUAGE](event);

      if (event.value != "keys") {
        const { value } = event;

        // Updating Settings User as well
        this.$store.dispatch(
          `${SettingsStoreNamespace}/${SettingsUserActionTypes.Users.UPDATE.SINGLE}`,
          {
            item: this.$store.getters.account.user,
            name: "language",
            value: value || "en",
          }
        );
        document.body.classList.remove("i18n-show-keys");
      } else {
        document.body.classList.add("i18n-show-keys");
      }
    },
    onAccountIconClick: function (event) {},
    onLogoutClick: function () {
      this[AccTypes.LOGOUT]();
    },
    onMyDetailsClick: function () {
      openModalRoute(this, "account_details", { mode: "add" });
    },
    onHeartBeatClick: function () {
      window.open(`${MHTTPCL.getBaseUrl()}${HEART_BEAT_URL}`, "_blank");
    },
    switchToV1: function () {
      // window.open(`${MHTTPCL.getBaseUrl()}/settings.pl?section=billing&action=update_billing_info`, "_blank");
    },
    onMyBillingClick: function () {
      this.$router.push({
        path: "/main/settings/billing",
      });
    },
    onNoticesClick: function () {
      this.$router.push({
        path: "/main/settings/notices/",
      });
    },
    onHelpClick: function () {
      let target = `https://details.zendesk.com/hc/en-us/`;
      const currentRoute = location.href.split("#")?.[1]; // /main/catalog/products
      console.log("Show path ", currentRoute);

      // if (currentRoute.startsWith(`/main/catalog/products`)) {
      // if (currentRoute.startsWith(`/main/catalog`)) {
      //   target = `${target}sections/360001057137-Products`;
      // } else if (currentRoute.startsWith(`/main/contacts`)) {
      //   // target= `https://details.zendesk.com/hc/en-us/categories/360000535958-LABEL`
      //   target = `${target}sections/360001028037-Contacts`;
      // } else if (currentRoute.startsWith(`/main/booking`)) {
      //   target = `${target}sections/360001043758-Calendar`;
      //   // Booking-> Artist---> articles/360003567717-Booking-Artists
      // } else if (currentRoute.startsWith(`/main/royalty`)) {
      //   target = `${target}sections/360001043878-Royalty`;
      // } else if (currentRoute.startsWith(`/main/licencing`)) {
      //   target = `${target}sections/360001043898-Licensing`;
      // } else if (currentRoute.startsWith(`/main/distribution`)) {
      //   target = `${target}sections/360001043958-Accounts`;
      // } else if (currentRoute.startsWith(`/main/accounting`)) {
      //   target = `${target}sections/360001057417-Invoices`;
      // } else if (currentRoute.startsWith(`/main/settings`)) {
      //   target = `${target}sections/360001057497-General-Settings`;
      // }

      const zenMapKey = Object.keys(zenDeskMappings)
        .sort((a, b) => a < b)
        .find((key) => new RegExp(key).test(currentRoute));
      console.log(zenDeskMappings[zenMapKey]);

      window.open(`${target}${zenDeskMappings[zenMapKey]}`, "_blank");
    },
    onListRefresh() {
      refreshCurrentSubmodule();
    },
    //MARK: Methods
  },
};

const zenDeskMappings = {
  // Contacts
  "/main/contacts/contact_list": "articles/360003568077-Contacts-Contacts",
  "/main/contacts/groups": "articles/360003568457-Contacts-Groups",
  "/main/contacts/files": "articles/360003581077-Contacts-Files",
  "/main/contacts/Import_Export": "articles/360003568497-Contacts-Import-Merge",
  // Booking
  "/main/booking/calendar": "sections/360001043758-Calendar",
  "/main/booking/booking_list": "articles/360003531478-Booking-Booking-List",
  "/main/booking/tasks": "sections/360001043758-Calendar",
  "/main/booking/requests": "sections/360001043758-Calendar",
  "/main/booking/artists": "articles/360003567717-Booking-Artists",
  "/main/booking/promoters": "articles/360003569017-Booking-Promoters",
  "/main/booking/venues": "articles/360003531778-Booking-Venues",
  "/main/booking/templates": "articles/360003569057-Booking-Templates",
  "/main/booking/reports": "sections/360001043818-Reports",
  "/main/booking/plugins": "sections/360001043758-Calendar",
  // Catalog
  "/main/catalog/catalog_artists": "sections/360001057077-Artists",
  "/main/catalog/labels": "sections/360001043858-Labels",
  "/main/catalog/projects": "sections/360001057097-Projects",
  "/main/catalog/releases": "sections/360001057117-Releases",
  "/main/catalog/products": "sections/360001057137-Products",
  "/main/catalog/product_groups": "categories/360000535958-LABEL",
  "/main/catalog/tracks": "sections/360001057157-Tracks",
  "/main/catalog/plugins": "sections/360001057177-Plugins",
  // Royalty
  "/main/royalty/royalty_accounts":
    "articles/360003573837-How-to-set-up-a-ROYALTY-ACCOUNT",
  "/main/royalty/contracts":
    "articles/360003558098-How-to-set-up-a-Royalty-Contract-for-a-Distributed-Label",
  "/main/royalty/statements": "articles/360003574057-CREATE-ROYALTY-STATEMENTS",
  "/main/royalty/recoupable": "sections/360001043878-Royalty",
  // "/main/royalty/checklist": "value",

  // Licencing
  "/main/licencing/licence_accounts": "sections/360001043898-Licensing",
  "/main/licencing/licences": "articles/360003572817-Label-Licencing",
  // "key": "value",

  // Accounting
  "/main/accounting/invoices": "articles/360003533918-Accounting-Invoices",
  "/main/accounting/invoice_reminders":
    "articles/360003534018-Accounting-Invoice-Reminder",
  "/main/accounting/costs": "articles/360003533918-Accounting-Invoices",
  "/main/accounting/reports/invoice":
    "articles/360003533918-Accounting-Invoices",
  "/main/accounting/plugins": "articles/360003533918-Accounting-Invoices",
  // Settings
  "/main/settings/general": "articles/360003537638-General-Settings",
  "/main/settings/identities":
    "articles/360003534758-Identities-Invoice-Layouts",
  "/main/settings/users": "sections/360001044198-User-Settings",
  "/main/settings/booking": "sections/360001057557-Booking-Settings",
  "/main/settings/label": "sections/360001057517-Label-Settings",
  "/main/settings/promotion":
    "articles/360003535218-Add-custom-fields-to-a-Promoters",
  "/main/settings/accounting": "articles/360003576057-Accounting-Settings",
  "/main/settings/sharing": "articles/360003534738-Settings-Sharing-Menu",
  "/main/settings/custom_texts": "categories/360000535978-SETTINGS",
};

// pattern = [0-9]* target="2345" ------ test pattern to target => true
// pattern = [3-9]* target="2345" ------ test pattern to target => false
// pattern = [3-9]* target="345" ------ test pattern to target => true
// pattern = [3-9]* target="3" ------ test pattern to target => true
// pattern = [3-9]+ target="3" ------ test pattern to target => true
// pattern = [3-9]+ target="" ------ test pattern to target => false
// pattern = [0-9]+ target="" ------ test pattern to target => false
// pattern = [0-9]+ target="a" ------ test pattern to target => false
// pattern = [a-z]+ target="a" ------ test pattern to target => true
</script>

<style lang="scss">
.cmp-main-breadcrumb {
  &.top-toolbar {
    background: var(--bc-secondary);
    color: var(--text-secondary);

    display: flex;
    border-bottom: 1px solid var(--sprt-82);

    .toolbar__content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-direction: row;

      @media (min-width: 640px) {
      }

      .left-side {
        margin-left: 0px !important;
        height: 100%;
      }
      .left-side,
      .right-side {
        display: flex;
        align-items: center;
        margin-right: 0px !important;
      }
      .right-side {
        .dropdown {
          flex: 1;
          margin-right: -5px;
        }

        button {
          flex: 1;
          margin-right: 15px;
          .dt-icon-container.user {
            // border-radius: 30px;
            // border: 1.0px solid var(--sprt-1);
            // height: 30px;
            // width: 30px;
            margin-right: 0px;
          }
        }

        .switch-link {
          display: flex;
          button {
            width: 36px;
            background-color: rgba(255, 100, 0, 0.2);
            border: none;
            color: var(--text-primary);
            margin: 0 15px 0 0;

            &.no-bg {
              background: none;
              margin-right: 5px;
            }
          }
        }
      }

      .sidenav-button {
        flex: 1;
        color: #919090;
        margin-left: 3px;
      }
    }
  }

  // .breadcrumbs__item {
  //   font-size: 13px;
  //   color: var(--text-primary) !important;
  // }

  // .breadcrumbs li:nth-child(2n) {
  //     padding: 0 0px;
  //     margin: 0px;
  // }
}

.account-dropdown-menu {
  .dropdown--item {
    display: flex;
    .dropdown--item--text {
      flex: 1;
    }
    .dropdown--item--icon {
      flex: 0;
    }
  }
}

// Conditional i18n-show-keys Class Rules

.i18n-show-keys {
  .dt-ntable th > span {
    text-transform: inherit !important;
  }
  .list__group__header {
    text-transform: inherit !important;
  }

  .btn {
    text-transform: inherit !important;
  }

  .dt-grid-box .dt-box-header--name {
    text-transform: inherit !important;
  }

  .dt-grid-layout-container .dt-grid-layout .dt-grid-tab .dt-grid-tab--title {
    text-transform: inherit !important;
  }
  .i18n-text-key {
    color: rgb(201, 69, 69);
    font-weight: 700;
    text-transform: full-width;
  }

  .i18n-text-key-missing {
    color: red;
    font-weight: 900;
    transform: scale(1.5);
  }
}
</style>
